import { useOutletContext } from "react-router-dom";
import type { Deal, ScenarioResponse } from "../api/client";

interface DealContext {
  deal: Deal;
  setDeal: React.Dispatch<React.SetStateAction<Deal | null>>;
  scenarios?: ScenarioResponse[];
  setScenarios?: React.Dispatch<React.SetStateAction<ScenarioResponse[]>>;
}

export function useDealContext(): DealContext {
  return useOutletContext<DealContext>();
}
